import PropTypes from "prop-types";

import AuthTooltip from "../../AuthTooltip";

const OAuthButton = ({
  action,
  label,
  tooltipTitle,
  tooltipBody,
  iconSrc,
  authenticityToken,
}) => (
  <div className="position-relative">
    <form action={action} method="post" className="m-0">
      <input
        type="hidden"
        name="authenticity_token"
        value={authenticityToken}
      />
      <button
        type="submit"
        className="btn btn-outline-secondary btn-lg d-flex align-items-center justify-content-center w-100 position-relative py-0 auth-sso-button"
      >
        <img
          src={iconSrc}
          alt=""
          width="20"
          height="20"
          aria-hidden="true"
          className="position-absolute auth-sso-icon"
        />
        <span className="d-inline-flex align-items-center">{label}</span>
      </button>
    </form>
    <span className="position-absolute auth-sso-tooltip">
      <AuthTooltip title={tooltipTitle} body={tooltipBody} />
    </span>
  </div>
);

OAuthButton.propTypes = {
  action: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  tooltipTitle: PropTypes.string.isRequired,
  tooltipBody: PropTypes.string.isRequired,
  iconSrc: PropTypes.string.isRequired,
  authenticityToken: PropTypes.string.isRequired,
};

export default OAuthButton;
